import isNode from 'detect-node';

type GlobalObj = (Window | typeof global) & {
  [key: string]: any;
};

export const getGlobalWindow = (): GlobalObj => {
  if (isNode) {
    return global;
  }
  return window;
};

export const getUrlSearch = (name: string): string | null => {
  const win: GlobalObj = getGlobalWindow();
  return (win.QUERY ?? {})[name] ?? win?.localStorage?.getItem(`QUERY_${name}`);
};

interface CurrentDeviceInterface {
  ua: string;

  init(userAgent: string): void;

  ios(): boolean;

  android(): boolean;

  desktop(): boolean;

  isIphoneX(): boolean;

  isSpacialScreen(): boolean;

  isWeChat(): boolean;

  isFromApp(): boolean;

  isAppIphoneX(): boolean;
}

class Device implements CurrentDeviceInterface {
  ua = '';

  public init(userAgent: string) {
    this.ua = userAgent;
  }

  public ios(): boolean {
    return getUrlSearch('platform') === 'ios' || /iphone/g.test(this.ua);
  }

  public android(): boolean {
    if (!isNode) {
      this.ua = window.navigator.userAgent.toLowerCase();
    }

    return getUrlSearch('platform') === 'android' || this.ua.includes('android');
  }

  public desktop(): boolean {
    if (!isNode) {
      this.ua = window.navigator.userAgent.toLowerCase();
    }

    return !/mobile/g.test(this.ua) && !this.ios() && !this.android();
  }

  public isWeChat(): boolean {
    if (!isNode) {
      this.ua = window.navigator.userAgent.toLowerCase();
    }
    return /MicroMessenger/gi.test(this.ua);
  }

  public isIphoneX(): boolean {
    if (isNode) {
      return false;
    }
    this.ua = window.navigator.userAgent.toLowerCase();

    return /iphone/g.test(this.ua) && window.screen.height >= 812;
  }

  public isSpacialScreen(): boolean {
    if (isNode) {
      return false;
    }
    const rate: number = window.screen.height / window.screen.width;
    const limit: number = window.screen.height === window.screen.availHeight ? 1.8 : 1.65;
    return rate > limit;
  }

  public isFromApp(): boolean {
    return getUrlSearch('from') === 'app' || getUrlSearch('from') === '__from__';
  }

  public isAppIphoneX(): boolean {
    return this.isFromApp() && this.isIphoneX();
  }

  public appVersion(): string {
    return getUrlSearch('version') || '';
  }
}

export default new Device();
